/* jshint esversion: 6 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';

const SocialInputConfigWidget = (props) => {
    const [ preview, setPreview ] = useState(null);
    const [ isFetching, setIsFetching ] = useState(true);

    useEffect(() => {
        let constants = props.app.config.constants,
            previewRequest = {};

        if (props.input.type !== undefined && props.input.type) {
            let input = props.input
            previewRequest.type = input.type,
            previewRequest.profileFlag = true;

            if (input.scID !== undefined && input.scID) {
                previewRequest.scID = input.scID;
            } else if (input.inputId !== undefined && input.inputId) {
                previewRequest.inputId = input.inputId;
            } else if (input.credID !== undefined && input.credID) {
                previewRequest.credID = input.credID;
            }

            axios({
                url: `${props.app.config.apiUrl}/input/preview`,
                data: previewRequest,
                headers: { "Content-type": "application/json" },
                method: 'POST',
                withCredentials: true,
                responseType: 'json'
            })
            .then((response) => {
                let data = response.data;
                setPreview(data);
                setIsFetching(false);
            })
            .catch((error) => {
               setIsFetching(false)
            });
        }
    }, []);

    let ServiceIcon = IconFactory[ConstantMixin.getIconIndexByCode(props.psID)],
        description = 'Social Profile',
        constants = props.app.config.constants;

    switch (props.psID) {
        case constants.POST_SVC_FACEBOOK:
            description = 'Facebook Page';
            break;

        case constants.POST_SVC_INSTAGRAM_BUSINESS:
            description = "Instagram Profile";
            break;

        case constants.POST_SVC_TIKTOK:
            description = "TikTok Profile";
            break;

        case constants.POST_SVC_YOUTUBE:
            description = "YouTube Channel";
            break;

        default:
            break;
    }

    return (
        <div className="social-input-config-widget">
            <div className="network-id">
                <div className="sicw-icon">
                    <ServiceIcon bare={true}/>
                </div>
                <div className="sicw-desc">
                    {description}
                </div>
            </div>
            {preview ? (
                <div className="input-id">
                    <div className="input-avatar">
                        <SocialAvatar {...props} social={{
                            psID: props.psID,
                            icon: preview.avatarUrl
                        }}
                        large={true}
                        hideServiceIcon={true}/>
                    </div>
                    <div className="input-info">
                        <div className="input-name">{preview.userName}</div>
                        <div className="input-link"><a href={preview.profileUrl} target="_blank">{preview.displayName}</a></div>
                    </div>
                </div>
            ) : null}
        </div>
    );

};


export default SocialInputConfigWidget;
